// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rich-text-editor-content {
  min-height: 200px;
  padding: 0.75rem;
  outline: none;
}

.rich-text-editor-content ul {
  list-style-type: disc;
  padding-left: 1.5rem;
  margin: 0.25rem 0;
}

.rich-text-editor-content ol {
  list-style-type: decimal;
  padding-left: 1.5rem;
  margin: 0.25rem 0;
}

.rich-text-editor-content h1 {
  font-size: 1.5rem;
  font-weight: 700;
  margin: 0.5rem 0;
}

.rich-text-editor-content h2 {
  font-size: 1.25rem;
  font-weight: 700;
  margin: 0.5rem 0;
}

.rich-text-editor-content h3 {
  font-size: 1.125rem;
  font-weight: 700;
  margin: 0.5rem 0;
}

.rich-text-editor-content p {
  margin: 0.25rem 0;
}

.rich-text-editor-content blockquote {
  border-left: 3px solid #d1d5db;
  margin: 0.5rem 0;
  padding-left: 1rem;
  color: #6b7280;
}
`, "",{"version":3,"sources":["webpack://./src/components/RichTextEditor.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;EACxB,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB","sourcesContent":[".rich-text-editor-content {\n  min-height: 200px;\n  padding: 0.75rem;\n  outline: none;\n}\n\n.rich-text-editor-content ul {\n  list-style-type: disc;\n  padding-left: 1.5rem;\n  margin: 0.25rem 0;\n}\n\n.rich-text-editor-content ol {\n  list-style-type: decimal;\n  padding-left: 1.5rem;\n  margin: 0.25rem 0;\n}\n\n.rich-text-editor-content h1 {\n  font-size: 1.5rem;\n  font-weight: 700;\n  margin: 0.5rem 0;\n}\n\n.rich-text-editor-content h2 {\n  font-size: 1.25rem;\n  font-weight: 700;\n  margin: 0.5rem 0;\n}\n\n.rich-text-editor-content h3 {\n  font-size: 1.125rem;\n  font-weight: 700;\n  margin: 0.5rem 0;\n}\n\n.rich-text-editor-content p {\n  margin: 0.25rem 0;\n}\n\n.rich-text-editor-content blockquote {\n  border-left: 3px solid #d1d5db;\n  margin: 0.5rem 0;\n  padding-left: 1rem;\n  color: #6b7280;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
